module.exports = __webpack_public_path__ + "static/media/wide.8726d214.jpg";